import './styles/gridByCategorie.scss';
import React, { Component } from 'react';
import Device from '../../devices/device';
import { cls } from '../../packages/components';
import CardGrid from './CardGrid';
import Utils from '../../utils/Utils';
import {ID_NAME_CARD_CHANNEL_CATEGORY} from "../Focus/constants";

class GridByCategorie extends Component {
    constructor(props) {
        super(props);
        this.channelsWrapper = null;
        this.keys = Device.getDevice().getKeys();
        this.rows = props.rows;
        this.cols = props.cols;
        this.segmentElements = [];
        this.quantity = props.cols * this.rows;
        this.totalPages = [];
        this.idxRow = 0;
        this.onMove = this.onMove.bind(this);
        this.firstLoad = this.firstLoad.bind(this);
        this.addIdx = this.addIdx.bind(this);
        this.getWith = this.getWith.bind(this);
        this.addRow = this.addRow.bind(this);
        this.getElements = this.getElements.bind(this);
        this.segmentGrid = this.segmentGrid.bind(this);
        this.createGrid = this.createGrid.bind(this);
        this.elementFocusableByID = 0;
        this.lastFocus = false;
        this.lastFocusUp = false;
        this.resetIdx = false;

        this.data = props.items;
        this.allItems = [];
        this.nextElements = [];

        this.state = {
            items: [],
            nextItems: [],
        };
    }

    onMove(e) {
        const dir = e.detail.direction;
        if (dir === 'down') {
            this.getElementsToDown(e.target, e);
        }
        if (dir === 'up') {
            this.getElementsToUp(e.target, e);
        }
    }

    getElementsToUp(lasElement) {
        const lastCol = parseInt(lasElement.getAttribute('data-col'));
        const isFirstElement = lasElement.getAttribute('data-isfirstitem') === 'true';
        let nextItems = [];

        if (!this.idxRow) {
            return this.idxRow = null
        } else {
            this.idxRow -= 1;
        }
        if (isFirstElement) {
            if (this.totalPages[this.idxRow] && this.totalPages[this.idxRow][0]) {
                const tmp = this.totalPages[this.idxRow][0].idx_focus;
                const grid = this.getElements(tmp);
                // Obteniendo el elemento a focusear
                if (this.totalPages[this.idxRow] && this.totalPages[this.idxRow][lastCol]) {
                    this.elementFocusableByID = this.totalPages[this.idxRow][lastCol].idx_focus;
                }

                // Obteniendo los siguientes elemento
                if (this.totalPages[this.idxRow + this.rows]) {
                    nextItems = this.totalPages[this.idxRow + this.rows];
                }

                this.setState({ items: grid, nextItems }, () => {
                  this.lastFocusUp = true;
                    setTimeout(() => {
                      const x = document.getElementById(ID_NAME_CARD_CHANNEL_CATEGORY + '_g_' + this.elementFocusableByID);
                      window.SpatialNavigation.makeFocusable();
                      window.SpatialNavigation.focus(x);
                    }, 0)
                });
            }
        }
    }

    getElementsToDown(lasElement) {
        const lastCol = parseInt(lasElement.getAttribute('data-col'));
        const lastrow = parseInt(lasElement.getAttribute('data-row'));
        let nextItems = [];
        this.idxRow = lastrow;
        const islast = lasElement.getAttribute('data-isLastItem') === 'true';
        if (this.resetIdx) {
            this.idxRow = 0;
            this.resetIdx = false;
        }
        // obteniendo el ultimo elemento de la fila
        if (this.idxRow === this.totalPages.length - 1) {
            this.idxRow = this.totalPages.length - 1;
            return;
        } else if(!this.idxRow) {
            this.idxRow = 0;
        } else {
            this.idxRow += 1;
        }
        if (islast) {
            if (
                this.totalPages[this.idxRow - (this.idxRow - (this.idxRow - 1)) - 1] &&
                this.totalPages[this.idxRow - (this.idxRow - (this.idxRow - 1)) - 1][0]
            ) {
                //Obteniendo el primero elemento de la una fila anterior
                const tmp = this.totalPages[this.idxRow - (this.idxRow - (this.idxRow - 1)) - 1][0]
                    .idx_focus;
                // obteniedo el siguient elemento para focusear
                if (this.totalPages[this.idxRow] && this.totalPages[this.idxRow][lastCol]) {
                    this.elementFocusableByID = this.totalPages[this.idxRow][lastCol].idx_focus;
                } else {
                    // No existe ese elemento;
                    if (
                        this.totalPages[this.idxRow] &&
                        this.totalPages[this.idxRow] &&
                        this.totalPages[this.idxRow].length > 0
                    ) {
                        this.elementFocusableByID = this.totalPages[this.idxRow][
                            this.totalPages[this.idxRow].length - 1
                        ].idx_focus;
                    }
                }

                // Obteniendo los siguientes elemento
                if (this.totalPages[this.idxRow + 1]) {
                    nextItems = this.totalPages[this.idxRow + 1];
                }
                const grid = this.getElements(tmp);
                this.setState({ items: grid, nextItems }, () => {
                  this.lastFocus = true;
                  setTimeout(() => {
                    const x = document.getElementById(ID_NAME_CARD_CHANNEL_CATEGORY + '_g_' + this.elementFocusableByID);
                    window.SpatialNavigation.makeFocusable();
                    window.SpatialNavigation.focus(x);
                  }, 0)
                });
            }
        }
    }

    componentDidMount() {
        document.addEventListener('sn:willmove', this.onMove);
        this.firstLoad();
    }

    componentWillUnmount() {
        document.removeEventListener('sn:willmove', this.onMove);
    }

    componentWillReceiveProps(newProps) {}

    componentDidUpdate(prevProps, prevState) {}

    getWith() {
        return 100 / this.cols;
    }

    firstLoad() {
        let nextItems = [];
        // SE CREA UN INDICE DE FOCO
        this.addIdx();
        // SE CREAR EL TOTAL DE PAGINAS
        this.totalPages = this.createGrid(this.data);
        // SE ASIGNA EL NUMERO DE FILA A CADA ELEMENTO
        this.addRow();
        const grid = this.getElements(0);

        if (this.totalPages[this.rows]) {
            nextItems = this.totalPages[this.rows];
        }

        this.setState({ items: grid, nextItems }, () => {
            const x = document.getElementById(ID_NAME_CARD_CHANNEL_CATEGORY + '_g_' + this.elementFocusableByID);
            window.SpatialNavigation.makeFocusable();
            window.SpatialNavigation.focus(x);
        });
    }

    addIdx() {
        this.data = this.data.map((el, idx) => {
            el.idx_focus = idx;
            return el;
        });
    }

    addRow() {
        this.totalPages.map((element, idx) => {
            element.map((el, col) => {
                for (const x in this.data) {
                    if (this.data[x].idx_focus === el.idx_focus) {
                        this.data[x].idx_row = idx;
                        this.data[x].idx_col = col;
                    }
                }
            });
        });
    }

    getElements(idx) {
        this.segmentElements = this.segmentGrid(this.data, idx, this.quantity);
        const grid = this.createGrid(this.segmentElements);
        return grid;
    }

    segmentGrid(array, index, total) {
        let result = array.slice(index, total + index);
        return result;
    }

    createGrid(data) {
        let grid = [];
        let flag = false;
        if (data.length > this.cols) {
            for (let i = 0, row = data.length; i < row; i += this.cols) {
                let aRow = data.slice(i, i + this.cols).map((item) => item.id);
                if (this.allItems.length !== 0) {
                    this.allItems.forEach((item) => {
                        for (let j = 0; j < aRow.length; j++) {
                            if (item === aRow[j]) {
                                flag = true;
                            }
                        }
                    });
                    if (!flag) {
                        this.allItems.push(...aRow);
                        flag = false;
                    }
                } else this.allItems.push(...aRow);
                grid.push(data.slice(i, i + this.cols));
            }
        } else if (data.length) {
            grid = [data];
        }
        return grid;
    }

    handleMouseEnter = (e) => {
        Utils.handleMouseEnter(e)
    }

    render() {
        const { items = [], nextItems = [] } = this.state;
        return (
            <div className="channels-categories-wrapper" id="grid_modal_wrapper">
                {items &&
                    Array.isArray(items) &&
                    items.map((row, index, array) => {
                        return (
                            <div className={cls(`channels-categories-row`)}>
                                {row &&
                                    Array.isArray(row) &&
                                    row.map((col) => {
                                        {
                                            return (
                                                <div
                                                    style={{ width: `${this.getWith()}%` }}
                                                    className={cls(`channels-categories-col`)}
                                                >
                                                    <a
                                                        className={cls(
                                                            `channels-categories-children`,
                                                            `${col && col.channel_number ? 'channels-categories-children-channels' : 'channels-categories-children-categories'}`,
                                                            `focusable`
                                                        )}
                                                        data-col={col.idx_col}
                                                        data-row={col.idx_row}
                                                        id={ID_NAME_CARD_CHANNEL_CATEGORY + '_g_' + col.idx_focus}
                                                        data-id={col.idx_focus}
                                                        data-isLastItem={index === array.length - 1}
                                                        data-isFirstItem={index === 0}
                                                        href="javascript:void(0)"
                                                        tabindex={0}
                                                        onClick={() => {
                                                            typeof this.props.onClick ===
                                                                'function' &&
                                                                this.props.onClick(col);
                                                        }}
                                                        onMouseEnter={() => this.handleMouseEnter('g_' + col.idx_focus)}
                                                    >
                                                        <CardGrid item={col}/>
                                                        <div className='num_channel_div'>{col.channel_number}</div>
                                                    </a>
                                                </div>
                                            );
                                        }
                                    })}
                            </div>
                        );
                    })}
                {nextItems &&
                    Array.isArray(nextItems) &&
                    <div className={cls(`channels-categories-row`)}>
                        {
                            nextItems.map((col) => {
                                return (
                                        <div
                                            style={{ width: `${this.getWith()}%`, height:'43px', padding:'10px 10px 0px 10px' }}
                                            className={cls(`channels-categories-col`)}>
                                                <div className={cls(`channels-categories-down`)}>
                                                </div>
                                        </div>
                                );
                            })
                        }
                    </div>}
            </div>
        );
    }
}

export default GridByCategorie;



// WEBPACK FOOTER //
// ./src/components/Epg/GridByCatetogorie.jsx